export const CONFIG = {
  INSTYLE_API_URL: process.env.GATSBY_INSTYLE_API_URL,
}
